import { render, staticRenderFns } from "./basic-table.vue?vue&type=template&id=0052bc01&"
import script from "./basic-table.vue?vue&type=script&lang=js&"
export * from "./basic-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports